import { render, staticRenderFns } from "./MonthlyEPFPublic.vue?vue&type=template&id=2487bcb8&scoped=true"
import script from "./MonthlyEPFPublic.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2487bcb8",
  null
  
)

export default component.exports